// removed by extract-text-webpack-plugin
module.exports = {"auftragRow":"auftragRow__3y2Be","auftrag":"auftrag__X17-q","position":"position__3xMRM","buttonWrapper":"buttonWrapper__2sqRM"};